<div class="hide-desktop">
    <div class="text-center border-dashed p-3 m-3">
        Your application is being created
    </div>
    <div class="title mx-3 my-1 shadow-sm p-3 pb-1">
        <h1 class="h1">APPLICATION WIZARD</h1>
    </div>
    <div class="d-flex flex-row mx-3 my-1 shadow-sm p-3">
        <button mat-icon-button class="bg-active color-white me-2">1</button>
        <div>
            <h2 class="h2 fs-4 color-active">Configure the Application</h2>
            <span>In Progress</span>
        </div>
        <button mat-icon-button class="me-2 ms-auto" (click)="dialogService.viewCertWizController(addWizObj, false)"><mat-icon>keyboard_arrow_down</mat-icon></button>
    </div>
</div>


<div class="container px-0 max-w-100">
    <div class="row mx-0">
        <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 py-4 left-bar-desktop hide-mobile">
            <app-cert-wiz-controller></app-cert-wiz-controller>
        </div>
        <div class="col-sm-12 col-md-9 col-lg-9 col-xl-9 py-4-">
            <div class="primary">
                <div class="text-center border-dashed p-3 m-3 hide-mobile">
                    Your application is being created
                </div>
                <div class="d-flex flex-row-reverse border-bottom pb-3">
                    <!-- <a mat-stroked-button color="accent">Help</a> -->
                </div>
                <ng-template [ngTemplateOutlet]="CertificationWizard"></ng-template>
            </div>
        </div>
    </div>
</div>


<!--after conversion-->
<ng-template #CertificationWizard>
    <div class="py-3 primary">
        <div *ngIf="isCertWizStarted">
            <div  class="mx-auto" *ngIf="!certWizService.certWizard.isComplete">
                <app-question-wizard  [questions]="certWizService.certWizard.questions"></app-question-wizard>
            </div>
            <div *ngIf="certWizService.certWizard.isComplete" class="mt-5 pt-5 mx-auto">
                <div class="text-center">
                    <h1 class="h1 text-center">APPLICATION WIZARD</h1>
                    <h3>The system is ready to start an application.</h3>
                    <h3 class="text-start mx-auto" style="max-width: 720px;">You cannot go back to change any information once you launch the application. If changes are needed after the application is launched, you must delete the application and start over and/or reapply with additional fees.</h3>
                </div>
                <div class="d-flex justify-content-center flex-wrap">
                    <button mat-stroked-button color="accent" (click)="back()" class="my-2">Back</button>
                    <button (click)="createNewApp()" mat-raised-button color="accent" aria-label="Launch Application" class="mx-2 my-2">Launch Application</button>
                </div>
            </div>
        </div>
        <div *ngIf="!isCertWizStarted" class="mt-5 pt-5  mx-auto">
            <div class="text-center" style="min-height: 200px;">
                <h1 class="h1 text-center">WELCOME TO THE APPLICATION WIZARD!</h1>
                <h3 class="text-start mx-auto" style="max-width: 720px;">By answering these questions we can ensure we gather the right information from you during the application so that the process is as seamless and quick as possible</h3>
            </div>
            <div class="d-flex justify-content-start flex-wrap">
                <button mat-stroked-button color="accent" (click)="location.back()" class="my-2">Back</button>
                <button (click)="initCertWizard()" mat-raised-button color="accent" aria-label="Launch Application" class="mx-2 my-2">I'M READY, LETS START</button>
            </div>
        </div>
    </div>
</ng-template>